import React from "react"

const QpBottomPanel = ({ fillColor, strokeColor }) => (
  <g id="bottom-panel">
    <path fill={fillColor} d="M480.687 432.054c-.8-42.2-2.5-52.601-2.5-52.601s-32.7 26.201-83.2 25.401v156.899c0 15-3 35-20 67s-133 11-133 11-153-54-187-75-34-57-34-57-5.9-100-10.3-196.8l-2.6 12.901s13 193.099 16.1 201.099c3.1 8 15.8 41.201 64.8 58.201s155.5 58.799 155.5 58.799 121 13.1 144.7-.5c31.7-18.2 62.799-49.999 67.099-57.299 18.6-31.7 26.401-43.9 24.401-152.1Z" fillRule="nonzero"/>
    <g stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round">
      <path d="M480.687 432.054c-.8-42.2-2.5-52.601-2.5-52.601s-32.7 26.201-83.2 25.401v156.899c0 15-3 35-20 67s-133 11-133 11-153-54-187-75-34-57-34-57-5.9-100-10.3-196.8l-2.6 12.901s13 193.099 16.1 201.099c3.1 8 15.8 41.201 64.8 58.201s155.5 58.799 155.5 58.799 121 13.1 144.7-.5c31.7-18.2 62.799-49.999 67.099-57.299 18.6-31.7 26.401-43.9 24.401-152.1Z" strokeWidth="3" strokeMiterlimit="10"/>
    </g>
  </g>
)

export default QpBottomPanel
